import API from "@/api";

export default class Service {
	activeRequests = [];
	async fetchVehicles() {
		const requestName = "fetchVehicles";

		const openRequest = this.activeRequests.find(
			x => x.requestName == requestName
		);
		if (openRequest) {
			openRequest.abortController.abort();
			delete this.activeRequests[requestName];
		}

		const abortController = new AbortController();
		const signal = abortController.signal;

		const promise = API.fetchJson(
			API.ENDPOINTS.GET_FLEET_TRACKER_VEHICLES,
			{ signal },
			e => {
				throw e;
			}
		).then(response => {
			delete this.activeRequests[requestName];
			return response;
		});
		this.activeRequests.push({ requestName, abortController });
		return promise;
	}
}
